import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import '../../styles/Pages.css';

function TeacherList() {
    const teachers = [
        { sr: 1, name: 'Dr. Sahadeo Aher', dept: 'Management / Principal', qualification: 'M.Sc., Ph.D.', post: 'Principal' },
        { sr: 2, name: 'Faculty Member', dept: 'Arts', qualification: 'M.A., B.Ed.', post: 'Assistant Professor' },
        { sr: 3, name: 'Faculty Member', dept: 'Science (Physics)', qualification: 'M.Sc.', post: 'Assistant Professor' },
        { sr: 4, name: 'Faculty Member', dept: 'Science (Chemistry)', qualification: 'M.Sc.', post: 'Assistant Professor' },
        { sr: 5, name: 'Faculty Member', dept: 'Science (Botany)', qualification: 'M.Sc.', post: 'Assistant Professor' },
        { sr: 6, name: 'Faculty Member', dept: 'Science (Zoology)', qualification: 'M.Sc.', post: 'Assistant Professor' },
        { sr: 7, name: 'Faculty Member', dept: 'Computer Science', qualification: 'M.C.S./M.Sc. CS', post: 'Assistant Professor' },
        { sr: 8, name: 'Faculty Member', dept: 'Physical Education', qualification: 'M.P.Ed.', post: 'Director of Physical Education' },
        { sr: 9, name: 'Librarian', dept: 'Library', qualification: 'M.Lib.I.Sc.', post: 'Librarian' },
    ];
    return (
        <div className="page-wrapper">
            <Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › ICT Facilities › Teacher List</p>
                <h1>Teacher List</h1>
                <p>Faculty and staff of Shri Mulikadevi Mahavidyalaya, Nighoj.</p>
            </div>
            <div className="page-content">
                <div className="info-card">
                    <h2>Faculty Directory</h2>
                    <table className="data-table">
                        <thead><tr><th>Sr.</th><th>Name</th><th>Department</th><th>Qualification</th><th>Post</th></tr></thead>
                        <tbody>
                            {teachers.map(t => (
                                <tr key={t.sr}>
                                    <td>{t.sr}</td>
                                    <td style={{ fontWeight: 600 }}>{t.name}</td>
                                    <td>{t.dept}</td>
                                    <td>{t.qualification}</td>
                                    <td>{t.post}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <p style={{ fontSize: '0.83rem', color: '#999', marginTop: '0.8rem' }}>
                        * For the official detailed teacher list PDF, please visit the college office or contact{' '}
                        <a href="mailto:ascnighoj@gmail.com" style={{ color: '#2d6a4f' }}>ascnighoj@gmail.com</a>.
                    </p>
                </div>
            </div>
            <Footer />
        </div>
    );
}
export default TeacherList;
